import { createStructuredSelector } from 'reselect';
import {
  selectAccountID,
  selectAvailableBalance,
  selectCurrentBalance,
} from '../../../../../selectors/globalSelectors';

// To fetch recommend a grant data from global.
export const fetchRAGState = (state) => state.recommendGrant;

export const selectSelectedCharityEin = (state) => {
  const { selectedCharityEin } = fetchRAGState(state);
  return selectedCharityEin;
};

export const selectGrantPurposeName = (state) => {
  const { grantPurposeName } = fetchRAGState(state);
  return grantPurposeName;
};

export const selectGrantRecognition = (state) => {
  const { grantRecognition } = fetchRAGState(state);
  return grantRecognition;
};

export const selectGrantAmount = (state) => {
  const { grantAmount } = fetchRAGState(state);
  return grantAmount;
};

export const selectScheduleType = (state) => {
  const { scheduleType } = fetchRAGState(state);
  return scheduleType;
};

export const selectStartDate = (state) => {
  const { startDate } = fetchRAGState(state);
  return startDate;
};

export const selectAllocationType = (state) => {
  const { allocationType } = fetchRAGState(state);
  return allocationType;
};

export const selectNoOfPayments = (state) => {
  const { noOfPayments } = fetchRAGState(state);
  return noOfPayments;
};

export const selectSelectedCharityName = (state) => {
  const { selectedCharityName } = fetchRAGState(state);
  return selectedCharityName;
};

export const selectUserSelectedDateVal = (state) => {
  const { userSelectedDateVal } = fetchRAGState(state);
  return userSelectedDateVal;
};

export const selectEditMode = (state) => {
  const { edit } = fetchRAGState(state);
  return edit;
};

export const selectCharityBackPath = (state) => {
  const { selectedCharityRefPath } = fetchRAGState(state);
  return selectedCharityRefPath;
};

export const selectSelectedAllSharesAllPools = (state) => {
  const { allSharesAllPools } = fetchRAGState(state);
  return allSharesAllPools;
};

export const selectSelectedAllShares = (state) => {
  const { allShares } = fetchRAGState(state);
  return allShares;
};

export const recommendGrantPageDerivedStates = createStructuredSelector({
  selectedCharityName: selectSelectedCharityName,
  selectedCharityEin: selectSelectedCharityEin,
  grantPurposeName: selectGrantPurposeName,
  grantRecognitionId: selectGrantRecognition,
  grantAmount: selectGrantAmount,
  scheduleType: selectScheduleType,
  startDate: selectStartDate,
  userSelectedDateVal: selectUserSelectedDateVal,
  allocationType: selectAllocationType,
  noOfPayments: selectNoOfPayments,
  editMode: selectEditMode,
  charityBackPath: selectCharityBackPath,
  selectedAllSharesAllPools: selectSelectedAllSharesAllPools,
  selectedAllShares: selectSelectedAllShares,
  selectedAccountId: selectAccountID,
  availableBalance: selectAvailableBalance,
  currentBalance: selectCurrentBalance,
});
